import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { Loader2, CheckCircle2, ShoppingBag } from "lucide-react";
import { Button } from "@/web/components/ui/button";
import { Input } from "@/web/components/ui/input";

export default function ProductsIndex() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    try {
      const res = await fetch("/api/notify-signups", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) throw new Error();
      setStatus("success");
      setEmail("");
    } catch {
      setStatus("error");
    }
  };

  return (
    <>
      <Helmet><title>Cool Wave Online Store — Coming Soon</title></Helmet>
      <section className="py-20">
        <div className="container max-w-xl text-center">
          <div className="mx-auto mb-6 inline-flex h-14 w-14 items-center justify-center rounded-full bg-brand-50 text-brand">
            <ShoppingBag className="h-6 w-6" />
          </div>
          <h1 className="mb-3 text-4xl font-bold tracking-tight">Cool Wave Online Store</h1>
          <p className="mb-2 text-2xl font-semibold text-brand">Coming Soon</p>
          <p className="mb-8 text-body">
            We're building a curated online store for parts, accessories and select systems. Drop your email and we'll
            let you know the moment it's live.
          </p>

          {status === "success" ? (
            <div className="mx-auto inline-flex items-center gap-2 rounded-md bg-green-50 px-4 py-3 text-sm text-green-700">
              <CheckCircle2 className="h-4 w-4" /> Thanks — we'll be in touch.
            </div>
          ) : (
            <form onSubmit={submit} className="mx-auto flex w-full max-w-md gap-2">
              <Input
                type="email"
                required
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Button type="submit" disabled={status === "loading"}>
                {status === "loading" ? <Loader2 className="h-4 w-4 animate-spin" /> : "Notify me"}
              </Button>
            </form>
          )}
          {status === "error" && <p className="mt-3 text-sm text-destructive">Something went wrong. Please try again.</p>}
        </div>
      </section>
    </>
  );
}
